import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';

export const fetchTipoServicioSelect = async () => {
  const query = `
    query {
      allTiposervicio {
        id
        codigo
      }
    }
  `;
  try {
    const response = await axios.post(rutas.axios + 'api', { query });

    return response.data.data.allTiposervicio.map(
      item => ({
        value: item.id,
        text: item.codigo
      })
    );

  } catch (error) {
    console.error("Error fetching Tipo cobertura:", error);
    return error;
  }
}